import { PropTypes } from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux';
import { Route } from "react-router-dom";
import history from '../hooks/history';

export default function PrivateRoute({ children, actor, ...rest }) {
    const { user } = useSelector(state => state.reducer_user)



    let val = false,
        msg = 'Please Login, then try again.';

// TODO: REMOVE THIS ON PRODUCTION
    // if (!process.env.localhost) {
    //     val = true
    // }
    // else {

        if (actor === 'seller' && user.isAuthenticated) {
            val = user.isSeller;
            msg = 'Seller Aria Restriction'
        }
        else if (actor === 'admin' && user.isAuthenticated) {
            val = user.isAdmin;
            msg = 'Admin Aria Restriction'
        }

        if (user?.isSuperAdmin) {
            val = true;
        }

    // }

    return (


        <Route {...rest} render={() => {
            //return user.isAuthenticated === true
            return val ?
                children :
                history.push('/MsgScreen/' + msg)
        }} />
    )
}
PrivateRoute.propTypes = {
    children: PropTypes.object,
    actor: PropTypes.string,
}
